module.exports = __webpack_public_path__ + "static/media/handshake.6c7fc158.svg";